import { useState } from 'react'
import { Box, Stack } from '@mui/material'
import { useRouting } from '@/core/hooks/useRouting'
import SvgLogo from '@/ui/components/svg/logo'
import { useCustomTheme, TTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'
import { SimpleMenu } from '@/ui/components/SimpleMenu'
import { MenuItem } from '@/ui/components/SimpleMenu/SimpleMenu'
import SettingsIcon from '@assets/images/settings-icon.svg?react'
import LogoutIcon from '@assets/images/logout.svg?react'
import {
    BodyText,
    ContactSupportButton,
    ExpiredScreenWrapper,
    MenuContainer,
} from './PolicyExpiredScreen.styles'
import { AccountModule } from '@/core/modules/account/account.module'

const PolicyExpiredScreen = () => {
    const theme = useCustomTheme() as TTheme
    const { handleLogout } = useRouting()
    const [menuOpen, setMenuOpen] = useState(false)
    const { expiredAccountsNames } = AccountModule.useStore()

    const menuItems: MenuItem[] = [
        {
            id: 'expired-logout',
            value: 'Log Out',
            action: () => handleLogout('policy_expired_screen'),
            leftIcon: (
                <LogoutIcon
                    height={14}
                    width={14}
                    color={theme.colors.greys[600]}
                />
            ),
        },
    ]

    const handleOpenChat = () => {
        window.Intercom('show')
    }

    const accountNames = expiredAccountsNames.join(', ')
    return (
        <ExpiredScreenWrapper>
            <MenuContainer>
                <SimpleMenu
                    onActivate={() => setMenuOpen(!menuOpen)}
                    open={menuOpen}
                    onClose={() => setMenuOpen(false)}
                    activator={
                        <SettingsIcon
                            height={22}
                            width={22}
                            color={theme.colors.greys[600]}
                        />
                    }
                    openLeft={true}
                    dataTestId="expired-settings-menu"
                    items={menuItems}
                    menuPosition="fixed"
                />
            </MenuContainer>
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                minHeight="100vh"
                width="100%"
            >
                <Stack
                    flex={1}
                    alignItems="center"
                    justifyContent="center"
                    textAlign="center"
                    mx="auto"
                    gap="42px"
                    height="530px"
                >
                    <Box lineHeight={0}>
                        <SvgLogo
                            width={89}
                            height={50}
                            primaryColor={theme.colors.greys[800]}
                            secondaryColor={theme.colors.primary[300]}
                        />
                    </Box>
                    <Stack gap={'32px'}>
                        <Typography
                            variant="xxxl-bold"
                            component="h1"
                            color={theme.colors.greys[800]}
                            noWrap={false}
                            testId="policy-expired-title"
                        >
                            Policy Expired
                        </Typography>
                        <Box>
                            <BodyText variant="l-regular" noWrap={false}>
                                The following accounts have expired policies:
                            </BodyText>
                            <BodyText variant="l-bold" noWrap={false}>
                                {accountNames}
                            </BodyText>
                            <BodyText variant="l-regular" noWrap={false}>
                                Access is currently unavailable for these
                                accounts.
                            </BodyText>
                        </Box>
                        <Box>
                            <BodyText variant="l-regular" noWrap={false}>
                                If you believe this is an error or need
                                assistance, please contact us.
                            </BodyText>
                            <ContactSupportButton onClick={handleOpenChat}>
                                Contact Support
                            </ContactSupportButton>
                        </Box>
                    </Stack>
                </Stack>
            </Box>
        </ExpiredScreenWrapper>
    )
}

export default PolicyExpiredScreen
